export default __webpack_public_path__ + "static/media/support-img-2.e2de79c7.jpg";